import React, { useState } from 'react';
import './AddCSV.css';

function AddCSV() {
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && !selectedFile.name.toLowerCase().endsWith('.csv')) {
      setError('Please select a CSV file');
      setFile(null);
    } else {
      setError(null);
      setFile(selectedFile);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setError('No file selected');
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append('csv_file', file);

    try {
      const token = localStorage.getItem('admin_token');
      if (!token) {
        setError('No admin authentication token found. Please log in as an admin at /admin-login.');
        return;
      }

      const url = 'https://valleyapi-dr9y.onrender.com/admin/products/addcsv';
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const text = await response.text();
        let errorMessage;
        switch (response.status) {
          case 400:
            errorMessage = 'Bad Request: No CSV file uploaded or invalid file type.';
            break;
          case 401:
            errorMessage = 'Unauthorized: Invalid or expired admin token. Please log in again at /admin-login.';
            break;
          case 403:
            errorMessage = 'Forbidden: Admin role required.';
            break;
          case 404:
            errorMessage = 'Endpoint not found: Ensure /admin/products/addcsv is registered in csv-upload.js and mounted at /admin in server.js.';
            break;
          case 500:
            errorMessage = 'Server error: Check server logs for issues in csv-upload.js or database connectivity.';
            break;
          default:
            errorMessage = `HTTP error: ${response.status}`;
        }
        throw new Error(`${errorMessage}. Response starts with: ${text.slice(0, 50)}...`);
      }

      const data = await response.json();
      window.location.href = `/admin/batches/${data.batchId}`;
    } catch (err) {
      console.error('Error uploading CSV:', err);
      setError(err.message || 'Error uploading CSV');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-csv-container">
      <h1>Upload Product CSV</h1>
      <form onSubmit={handleSubmit} className="add-csv-form">
        <div className="form-group">
          <label>Select CSV File</label>
          <input
            type="file"
            accept=".csv"
            onChange={handleFileChange}
            className="file-input"
          />
          {error && <p className="error">{error}</p>}
        </div>
        <button
          type="submit"
          disabled={loading || !file}
          className="submit-button"
        >
          {loading ? 'Uploading...' : 'Next'}
        </button>
      </form>
    </div>
  );
}

export default AddCSV;